<form [formGroup]="form">
  <section>
    <span class="section-title">{{ "shared.media" | translate }}</span>
    <div class="images-grid">
      <app-multiple-image-or-video-uploader
        [type]="type"
        [control]="form.controls.images"
        [form]="form"
        [fields]="fields"
        [maxNumFiles]="20"
        [availableNumFiles]="20 - (form.controls.images.value?.length ?? 0)"
      />
      @for (image of form.controls.images.value; track $index) {
        <app-media-preview
          [media]="image"
          (remove)="onActionDeleteMedia(form.controls.images, $index)"
        />
      }
    </div>
    <span class="info">
      <mat-icon>info_outline</mat-icon>
      <span>
        {{
          "publicationTemplate.create.facebookPost.images.moreInfo" | translate
        }}
      </span>
    </span>
  </section>
  <section>
    <span class="section-title">{{ "shared.text" | translate }}</span>
    <span class="section-description">{{
      "publicationTemplate.create.facebookPost.text.description" | translate
    }}</span>
    <app-publication-text-editor [control]="form.controls.text" />
  </section>
</form>
